import { createUseStyles, useTheme } from "react-jss"
import SingleSelection from "../../components/Filters/SingleSelection"
import { useAppDispatch, useAppSelector } from "../../util/hooks"
import { theme as baseTheme } from "../../util/CustomTheme"
import dayjs from "dayjs"
import {
  ALERT_STATUS_MSGS,
  DATE_FORMAT,
  DAYS,
  DAYS_TO_NUMBER_MAPPER,
  monthlyStaticOptions,
  timePeriodOptionsMaintenance,
  timeZoneOptions,
  TOAST_OPTS,
} from "../../util/StaticData"
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControlLabel,
  IconButton,
  ThemeProvider,
  Typography,
  checkboxClasses,
  createTheme,
  styled,
} from "@mui/material"
import {
  DatePicker,
  LocalizationProvider,
  TimePicker,
} from "@mui/x-date-pickers"
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns"
import { theme } from "../../util/theme"
import CloseIcon from "@mui/icons-material/Close"
import {
  closeScheduleDialog,
  endDateChange,
  frequencyChange,
  maintenanceScheduleDefaultRunAsync,
  recurrencePatternChange,
  removeMonthlySelectedDays,
  resetMonthlySelectedDays,
  startDateChange,
  timeChange,
  timeZoneChange,
  updateMonthlySelectedDays,
} from "./MaintenanceSlice"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { DayCell } from "../../components/DayCell"
import { IMonthlyStaticOption } from "../../util/interface"
import { useEffect, useRef, useState } from "react"
import cronstrue from "cronstrue"
import {
  format,
  getHours,
  getMinutes,
  isAfter,
  isEqual,
  isPast,
  isValid,
  parseISO,
  set,
} from "date-fns"
import { setAlertData, setAlertData2 } from "../Monitor/MonitorSlice"
import { toast } from "react-toastify"

const useStyles = createUseStyles({
  label: {
    color: "var(--dark-neutrals-dark, #333)",
    fontFamily: ({ theme }: any) => theme.primaryFontFamily,
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "150%", // You can keep this as a string or convert it to '1.5' for 150%
    marginRight: 10,
    minWidth: 120,
    maxWidth: (props: any) => {
      return props["maxWidth"]
    },
  },
  container: {
    height: 210,
    display: "grid",
    gridTemplateColumns: "32px 1fr",
    alignContent: "space-evenly",
  },
  runLabel: {},
  date: {},
  time: {},
  timezone: {},
  runContainer: {
    display: "flex",
    flexDirection: "column",
    color: "#000",
    fontSize: "14.571px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "normal",
  },
  runInnerWrapper: {
    display: "flex",
    gap: 10,
  },
  divider: {
    border: "1px solid black",
    height: 20,
    width: 1,
  },
  commonFilterContainer: {
    display: "grid",
    alignItems: "center",
    minHeight: 40,
    gap: 30,
    gridTemplateColumns: "127px 297px",
  },
  commonFilterContainer2: {
    display: "grid",
    alignItems: "center",
    minHeight: 40,
    gap: 30,
    gridTemplateColumns: "50px 170px",
  },
  scheduleContainer: {
    display: "flex",
    gap: 10,
    flexDirection: "column",
  },
  dayWrapper: {
    display: "flex",
    gap: 3,
    flexWrap: "wrap",
  },
  btnWrapper: {
    display: "flex",
    justifyContent: "flex-end",
  },
  backBtn: {
    borderRadius: "7px",
    height: "27px",
    width: "66px",
    color: "black",
    fontSize: "12px",
    fontStyle: "normal",
    lineHeight: "normal",
    textDecoration: "underline",
  },
  nextBtn: {
    borderRadius: "7px",
    // background: "#E21824",
    height: "27px",
    width: "fit-content",
    paddingLeft: 10,
    paddingRight: 10,
    color: "#FFF",
    fontFamily: "Roboto",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "normal",
  },
})
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}))
export const themeMui = createTheme({
  ...baseTheme,
  components: {
    MuiInputBase: {
      styleOverrides: {
        root: {
          fontSize: 14,
          height: 31,
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          color: theme.dayLabelColor,
          fontWeight: 500,
          fontSize: 14.57,
        },
      },
    },
  },
})
export const ScheduleDefaultRun = () => {
  const theme: any = useTheme()
  const dispatch = useAppDispatch()
  const classes = useStyles({ theme })
  const handleChangeTime = (newTime: any) => {
    if (isValid(newTime)) {
      dispatch(timeChange(newTime.toISOString()))
    } else {
      dispatch(timeChange(null))
    }
  }
  // selector state from the store
  const timeZone = useAppSelector(
    (state) => state.maintenance.defaultScheduleRun.timeZone,
  )
  const frequency = useAppSelector(
    (state) => state.maintenance.defaultScheduleRun.frequency,
  )
  const time = useAppSelector((state) => {
    const val = state.maintenance.defaultScheduleRun.time
    if (val) {
      return dayjs(val).format("HH:mm")
    }
    return null
  })

  const timeWithoutFormat = useAppSelector(
    (state) => state.maintenance.defaultScheduleRun.time,
  )
  const [key, setKey] = useState(0)
  const resetTimePicker = () => {
    setKey((prevKey) => prevKey + 1)
  }
  const handleSubmit = async () => {
    // Parse the date part
    const parsedDate = parseISO(startDate) // Date in yyyy-MM-dd format

    // Extract the time manually
    const parsedTime = new Date(timeWithoutFormat)
    const hours = parsedTime.getHours()
    const minutes = parsedTime.getMinutes()

    const combinedDateTime = set(parsedDate, {
      hours,
      minutes,
      seconds: 0,
      milliseconds: 0,
    })

    // Check if the combined date and time are in the past
    const isDatePast = isPast(combinedDateTime)

    if (isDatePast) {
      toast.error("Start date and time should not be past", TOAST_OPTS)
      return
    }

    // end date should be greater than or equal to start date
    const isFuture =
      isAfter(parseISO(endDate), parseISO(startDate)) ||
      isEqual(parseISO(endDate), parseISO(startDate))

    if (!isFuture) {
      toast.error(
        "End date should be greater than or equal to start date",
        TOAST_OPTS,
      )
      return
    }
    handleClose()
    const response = await dispatch(maintenanceScheduleDefaultRunAsync())
    if (response && response.payload.data) {
      dispatch(
        setAlertData2(
          setAlertData(response.payload.data, ALERT_STATUS_MSGS.SUCCESS, true),
        ),
      )
    }
  }
  const timezoneFilterOptions = timeZoneOptions
  const handleClose = () => {
    dispatch(closeScheduleDialog())
  }
  const isModalOpen = useAppSelector(
    (store) => store.maintenance.isScheduleModelOpen,
  )
  const startDate: any = useAppSelector(
    (state) => state.maintenance.defaultScheduleRun.rangeOfRecurrence.start,
  )
  const endDate: any = useAppSelector(
    (state) => state.maintenance.defaultScheduleRun.rangeOfRecurrence.end,
  )
  const handleStartDateChange = (newDate: any) => {
    try {
      if (dayjs(newDate)?.isValid()) {
        dispatch(startDateChange(newDate.toISOString()))
      } else {
        dispatch(startDateChange(null))
      }
    } catch (error) {
      console.error(error)
      dispatch(startDateChange(null))
    }
  }
  const handleEndDateChange = (newDate: any) => {
    try {
      if (dayjs(newDate)?.isValid()) {
        dispatch(endDateChange(newDate.toISOString()))
      } else {
        dispatch(endDateChange(null))
      }
    } catch (error) {
      console.error(error)
      dispatch(endDateChange(null))
    }
  }
  const recurrencePatternChangeLocal = (e: any, day: string) => {
    if (recurrencePattern.includes(day)) {
      dispatch(
        recurrencePatternChange(recurrencePattern.filter((d) => d !== day)),
      )
    } else {
      const newRecurrencePattern = [...recurrencePattern, day]
      dispatch(recurrencePatternChange(newRecurrencePattern))
    }
  }
  const recurrencePattern: string[] = useAppSelector(
    (store) => store.maintenance.defaultScheduleRun.recurrencePattern,
  )
  const monthlySelectedDays = useAppSelector(
    (store) => store.maintenance.monthlySelectedDays,
  )
  const dayCellClickHandle = (day: IMonthlyStaticOption) => {
    if (monthlySelectedDays.find((obj) => day.value === obj.value)) {
      dispatch(removeMonthlySelectedDays(day))
    } else {
      dispatch(updateMonthlySelectedDays(day))
    }
  }
  const [parsedCronStr, setParsedCronStr] = useState("")

  const rawTimeFromStore = useAppSelector(
    (store) => store.maintenance.defaultScheduleRun.time,
  )
  const resetOnFrequencyChange = () => {
    dispatch(recurrencePatternChange([]))
    dispatch(resetMonthlySelectedDays())
  }
  const [keyForDateReset, setKeyForDateReset] = useState("v1")
  const timePickerRef = useRef<any>(null) // Create a ref for the TimePicker
  // function for on reset
  const handleReset = () => {
    try {
      dispatch(recurrencePatternChange([]))
      dispatch(resetMonthlySelectedDays())
      dispatch(startDateChange(""))
      dispatch(endDateChange(null))
      dispatch(timeChange(null))
      dispatch(timeZoneChange(""))
      dispatch(frequencyChange(""))
      setKeyForDateReset(`${new Date().getTime()}`)
      if (timePickerRef.current) {
        timePickerRef.current.querySelector("input").value = "" // Clear the input field
      }
      resetTimePicker()
    } catch (error) {
      console.error(error)
    }
  }
  const autoFillRecurrencePatternForDaily = () => {
    dispatch(recurrencePatternChange(Object.keys(DAYS)))
  }
  // effect to set the cron text
  useEffect(() => {
    try {
      const date = new Date(rawTimeFromStore || "")
      const formattedTime = format(date, "hh:mm a").toUpperCase() // Convert to uppercase for AM/PM

      const selectedDaysArray = getSelectedDaysArray(monthlySelectedDays)

      const isMonthlyFrequency = frequency === "month"

      if (shouldGenerateCronString(frequency, selectedDaysArray)) {
        const rawCronStr = generateCronString(
          date,
          selectedDaysArray,
          recurrencePattern,
          frequency,
        )
        setParsedCronStr(cronstrue.toString(rawCronStr, { verbose: true }))
      }

      if (isMonthlyFrequency && containsLastDay(monthlySelectedDays)) {
        handleMonthlySpecialCase(selectedDaysArray, formattedTime)
      }
    } catch (error) {
      console.error(error)
    }
  }, [rawTimeFromStore, recurrencePattern, frequency, monthlySelectedDays])

  const getSelectedDaysArray = (monthlySelectedDays: any) =>
    monthlySelectedDays
      .map((obj: any) => obj.value)
      .filter((num: number) => num !== -1)

  const shouldGenerateCronString = (
    frequency: string,
    selectedDaysArray: any,
  ) =>
    frequency !== "month" ||
    (frequency === "month" && selectedDaysArray.length > 0)

  const generateCronString = (
    date: any,
    selectedDaysArray: any,
    recurrencePattern: any,
    frequency: string,
  ) => {
    const mins = getMinutes(date)
    const hours = getHours(date)
    const selectedDates = selectedDaysArray.join(",")

    let selectedDaysForCron = recurrencePattern
      .map((val: any) => DAYS_TO_NUMBER_MAPPER[val])
      .join(",")

    if (frequency === "day") {
      selectedDaysForCron = Object.keys(DAYS_TO_NUMBER_MAPPER)
        .map((val) => DAYS_TO_NUMBER_MAPPER[val])
        .join(",")
    }

    return `${mins || mins === 0 ? mins : "*"} ${hours ? hours : "*"} ${
      selectedDates ? selectedDates : "*"
    } * ${selectedDaysForCron ? selectedDaysForCron : "*"}`
  }

  const containsLastDay = (monthlySelectedDays: any) =>
    monthlySelectedDays.some((day: any) => day.value === -1)

  const handleMonthlySpecialCase = (
    selectedDaysArray: any,
    formattedTime: any,
  ) => {
    let dayMessage =
      selectedDaysArray.length > 0 ? selectedDaysArray.join(", ") : ""

    if (selectedDaysArray.length === 1) {
      setParsedCronStr(`At ${formattedTime}, on the last day of the month.`)
    } else {
      dayMessage =
        selectedDaysArray.length > 1
          ? `${selectedDaysArray.slice(0, -1).join(", ")} and ${
              selectedDaysArray[selectedDaysArray.length - 1]
            }`
          : dayMessage

      setParsedCronStr(
        `At ${formattedTime}, on day ${dayMessage}, and the last day of the month.`,
      )
    }
  }

  const showParsedText = () => {
    if (frequency === "week" && !recurrencePattern.length) {
      return ""
    }
    if (frequency === "month" && !monthlySelectedDays.length) {
      return ""
    }
    if (time && frequency) {
      return parsedCronStr
    }
    return ""
  }

  // Utility function for background color
  const getButtonBackgroundColor = (
    startDate: any,
    endDate: any,
    frequency: string,
    timeZone: string,
    time: any,
    recurrencePattern: any,
  ) => {
    switch (true) {
      case !dayjs(startDate).isValid():
      case !dayjs(endDate).isValid():
      case !frequency:
      case !timeZone:
      case !time:
      case disableSchedule(frequency, recurrencePattern):
        return "lightgray"
      default:
        return "#25d4cf"
    }
  }

  // Utility function for button disabled state
  const isButtonDisabled = (
    startDate: any,
    endDate: any,
    frequency: string,
    timeZone: string,
    time: any,
    recurrencePattern: any,
  ) => {
    switch (true) {
      case !dayjs(startDate).isValid():
      case !dayjs(endDate).isValid():
      case !frequency:
      case !timeZone:
      case !time:
      case disableSchedule(frequency, recurrencePattern): // Applying disableSchedule here
        return true
      default:
        return false
    }
  }

  // Utility for specific recurrence pattern disable
  const disableSchedule = (frequency: string, recurrencePattern: any) => {
    switch (frequency) {
      case "week":
        return !recurrencePattern.length
      case "month":
        return !monthlySelectedDays.length
      default:
        return false
    }
  }

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={isModalOpen}
      fullWidth={true}
      maxWidth="sm"
    >
      <DialogTitle sx={{ m: 0, p: 1 }} id="customized-dialog-title">
        Schedule Default Run
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 20,
            zIndex: 100,
            top: 10,
            color: (theme) => theme.palette.grey[500],
            padding: "5px",
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <Divider />

      <DialogContent>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          <div>
            <div className={classes.scheduleContainer}>
              <div className={classes.commonFilterContainer}>
                {/* timezone dropdown */}
                <Typography variant="redLabel">Select Timezone:</Typography>
                <SingleSelection
                  minWidth={297}
                  maxWidth={297}
                  changeFunc={(value: string) =>
                    dispatch(timeZoneChange(value))
                  }
                  filterValue={timeZone}
                  options={timezoneFilterOptions}
                  isSearchable={true}
                  label="Timezone"
                  minHeight={29}
                  isDisabled={false}
                  showLabel={false}
                />
              </div>

              <div className={classes.commonFilterContainer}>
                {/* time dropdown */}
                <Typography variant="redLabel">Select Time :</Typography>
                <ThemeProvider theme={themeMui}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <TimePicker
                      label=""
                      sx={{
                        "& .MuiInputBase-input": {
                          minWidth: "233px",
                        },
                      }}
                      key={key}
                      disabled={false}
                      ref={timePickerRef} // Attach the ref
                      onChange={(newValue: any) => handleChangeTime(newValue)}
                    />
                  </LocalizationProvider>
                </ThemeProvider>
              </div>
              <div className={classes.commonFilterContainer}>
                {/* frequency dropdown */}
                <Typography variant="redLabel">Select Frequency:</Typography>
                <SingleSelection
                  minWidth={297}
                  maxWidth={297}
                  changeFunc={(value: string) => {
                    setParsedCronStr("")
                    dispatch(frequencyChange(value))
                    resetOnFrequencyChange()
                    if (value === "day") {
                      autoFillRecurrencePatternForDaily()
                    }
                  }}
                  filterValue={frequency}
                  options={timePeriodOptionsMaintenance}
                  isSearchable={true}
                  label="date"
                  minHeight={29}
                  isDisabled={false}
                  showLabel={false}
                />
              </div>
            </div>
          </div>
          <Divider />
          <div>
            {/* recurrence pattern input */}
            <Typography variant="redLabel">Recurrence Pattern:</Typography>
            {frequency === "day" || frequency === "week" ? (
              <div className={classes.dayWrapper}>
                {Object.keys(DAYS).map((day: string) => {
                  return (
                    <div key={day}>
                      <ThemeProvider theme={themeMui}>
                        <FormControlLabel
                          disabled={frequency === "day"}
                          control={
                            <Checkbox
                              sx={{
                                [`&, &.${checkboxClasses.checked}`]: {
                                  color: theme.mainIndicationColor,
                                },
                              }}
                              onChange={(e) =>
                                recurrencePatternChangeLocal(e, day)
                              }
                              checked={recurrencePattern.includes(day)}
                            />
                          }
                          label={day}
                        />
                      </ThemeProvider>
                    </div>
                  )
                })}
              </div>
            ) : (
              <div className={classes.dayWrapper}>
                {monthlyStaticOptions.map((day: IMonthlyStaticOption) => {
                  let isActive
                  if (
                    monthlySelectedDays.find((obj) => obj.value === day.value)
                  ) {
                    isActive = true
                  } else {
                    isActive = false
                  }
                  return (
                    <div
                      key={day.value}
                      onClick={() => dayCellClickHandle(day)}
                    >
                      <DayCell text={day.label} active={isActive} />
                    </div>
                  )
                })}
              </div>
            )}
          </div>
          <Divider />

          <div>
            <Typography variant="redLabel"> Range of Recurrence:</Typography>
            <Box sx={{ display: "flex", gap: 1 }}>
              <Box className={classes.commonFilterContainer2}>
                {/* start date selection */}
                <div className={classes.label}>Start * :</div>
                <ThemeProvider theme={themeMui}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      label=""
                      key={keyForDateReset}
                      value={startDate ? dayjs(startDate) : null}
                      disablePast
                      onChange={(newValue) => handleStartDateChange(newValue)}
                      format={DATE_FORMAT.toUpperCase()}
                      sx={{
                        "& .MuiInputBase-input": {
                          minWidth: "100px",
                        },
                      }}
                    />
                  </LocalizationProvider>
                </ThemeProvider>
              </Box>
              <Box className={classes.commonFilterContainer2}>
                {/* end date selection */}
                <div className={classes.label}>End By* :</div>
                <ThemeProvider theme={themeMui}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      label=""
                      value={endDate ? dayjs(endDate) : null}
                      key={keyForDateReset}
                      minDate={startDate ? dayjs(startDate) : null}
                      disabled={!dayjs(startDate).isValid()}
                      disablePast
                      onChange={(newValue) => handleEndDateChange(newValue)}
                      format={DATE_FORMAT.toUpperCase()}
                      sx={{
                        "& .MuiInputBase-input": {
                          minWidth: "100px",
                        },
                      }}
                    />
                  </LocalizationProvider>
                </ThemeProvider>
              </Box>
            </Box>
          </div>
        </Box>
      </DialogContent>
      <Divider />
      <DialogActions>
        <Box
          sx={{
            display: "grid",
            alignItems: "center",
            minHeight: 45,
            width: "100%",
            gridTemplateColumns: "2fr 0.2fr",
          }}
        >
          <Typography component={"div"} variant={"redLabel"}>
            {/* {time && frequency ? parsedCronStr : ""} */}
            {showParsedText()}
          </Typography>
          <div className={classes.btnWrapper}>
            <button className={classes.backBtn} onClick={handleReset}>
              Reset
            </button>
            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
              <Button
                className={classes.nextBtn}
                sx={{
                  backgroundColor: getButtonBackgroundColor(
                    startDate,
                    endDate,
                    frequency,
                    timeZone,
                    time,
                    recurrencePattern,
                  ), // Passing recurrencePattern
                  "&:hover": {
                    backgroundColor: getButtonBackgroundColor(
                      startDate,
                      endDate,
                      frequency,
                      timeZone,
                      time,
                      recurrencePattern,
                    ), // Same for hover
                  },
                }}
                disabled={isButtonDisabled(
                  startDate,
                  endDate,
                  frequency,
                  timeZone,
                  time,
                  recurrencePattern,
                )} // Passing recurrencePattern
                onClick={handleSubmit}
              >
                Schedule
              </Button>
              ;
            </Box>
          </div>
        </Box>
      </DialogActions>
    </BootstrapDialog>
  )
}
